const Elmah = () => (
  <iframe
    src={process.env.REACT_APP_ELMAH_URL}
    title="Elmah"
    style={{ height: '100vh', width: '100vw', border: 'none' }}
  />
);

export default Elmah;
